<template>
  <div
    class="quote-block relative flex xl:flex-row max-lg:flex-col gap-10 max-lg:gap-5 p-10 max-xl:p-6 bg-accent-default rounded-[24px] overflow-hidden"
  >
    <svg
      class="absolute right-0 top-[-300%] w-[120%] max-lg:-top-60 max-lg:left-25 max-md:top-[50%] max-md:-left-12.5 max-md:12.5 max-md:scale-200 h-auto pointer-events-none opacity-60"
      width="1227"
      height="1222"
      viewBox="0 0 1227 1222"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M1203.69 294.102C1198.63 346.914 1169.94 377.754 1117.63 386.623C1065.33 395.493 1036.64 426.333 1031.57 479.145C1026.51 531.957 997.822 562.797 945.514 571.666C893.207 580.536 864.52 611.376 859.455 664.188C854.389 717 825.703 747.84 773.396 756.71C721.088 765.579 692.402 796.419 687.336 849.231C682.271 902.043 653.584 932.883 601.277 941.753C548.969 950.622 520.283 981.463 515.217 1034.27C510.152 1087.09 481.465 1117.93 429.158 1126.8C376.851 1135.67 348.164 1166.51 343.099 1219.32M1139.73 235.729C1134.67 288.54 1105.98 319.381 1053.67 328.25C1001.37 337.12 972.681 367.96 967.615 420.772C962.55 473.583 933.863 504.424 881.556 513.293C829.248 522.163 800.562 553.003 795.496 605.815C790.431 658.626 761.744 689.467 709.437 698.336C657.13 707.206 628.443 738.046 623.378 790.858C618.312 843.669 589.626 874.51 537.318 883.379C485.011 892.249 456.325 923.089 451.259 975.901C446.193 1028.71 417.507 1059.55 365.2 1068.42C312.892 1077.29 284.206 1108.13 279.14 1160.94M1075.78 177.355C1070.71 230.167 1042.02 261.008 989.716 269.877C937.409 278.746 908.723 309.587 903.657 362.398C898.591 415.21 869.905 446.051 817.598 454.92C765.29 463.789 736.604 494.63 731.538 547.442C726.473 600.253 697.786 631.094 645.479 639.963C593.172 648.833 564.485 679.673 559.42 732.485C554.354 785.296 525.667 816.137 473.36 825.006C421.053 833.876 392.366 864.716 387.301 917.528C382.235 970.339 353.549 1001.18 301.241 1010.05C248.934 1018.92 220.248 1049.76 215.182 1102.57M1011.82 118.982C1006.75 171.794 978.065 202.634 925.758 211.504C873.451 220.373 844.764 251.214 839.699 304.025C834.633 356.837 805.947 387.677 753.639 396.547C701.332 405.416 672.645 436.257 667.58 489.068C662.514 541.88 633.828 572.72 581.52 581.59C529.213 590.459 500.527 621.3 495.461 674.111C490.396 726.923 461.709 757.763 409.402 766.633C357.094 775.502 328.408 806.343 323.342 859.154C318.277 911.966 289.59 942.807 237.283 951.676C184.976 960.545 156.289 991.386 151.224 1044.2M947.859 60.609C942.794 113.421 914.107 144.261 861.8 153.13C809.492 162 780.806 192.84 775.74 245.652C770.675 298.464 741.988 329.304 689.681 338.174C637.374 347.043 608.687 377.883 603.622 430.695C598.556 483.507 569.87 514.347 517.562 523.217C465.255 532.086 436.568 562.927 431.503 615.738C426.437 668.55 397.751 699.39 345.443 708.26C293.136 717.129 264.45 747.97 259.384 800.781C254.319 853.593 225.632 884.433 173.325 893.303C121.017 902.172 92.3309 933.013 87.2654 985.824M883.901 2.23558C878.835 55.0472 850.149 85.8877 797.841 94.7571C745.534 103.627 716.847 134.467 711.782 187.279C706.716 240.09 678.03 270.931 625.723 279.8C573.415 288.67 544.729 319.51 539.663 372.322C534.598 425.133 505.911 455.974 453.604 464.843C401.296 473.713 372.61 504.553 367.544 557.365C362.479 610.176 333.792 641.017 281.485 649.886C229.178 658.756 200.491 689.596 195.426 742.408C190.36 795.219 161.674 826.06 109.366 834.929C57.0589 843.799 28.3725 874.639 23.3069 927.451"
        stroke="white"
        stroke-opacity="0.1"
        stroke-width="47"
      />
    </svg>

    <div class="quote-block flex flex-row gap-5 flex-1 z-10">
      <img
        class="quote-icon w-10 h-10 shrink-0"
        src="/images/schools/quote-icon.svg"
        alt=""
        aria-hidden="true"
        loading="lazy"
      />
      <p class="typo-paragraph-lg-regular leading-6 text-white">
        {{ quote }}
      </p>
    </div>

    <div class="author-block flex flex-row items-center gap-4 shrink-0 z-10">
      <img
        class="author-image w-15 h-15 rounded-xl border border-white object-cover"
        :src="authorImage"
        :alt="authorName"
        loading="lazy"
      />
      <div class="info flex flex-col gap-1">
        <span class="typo-heading-h5 text-white">
          {{ authorName }}
        </span>
        <span class="typo-paragraph-sm-regular text-white/70">
          {{ authorRole }}
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineOptions({
  name: 'QuoteBlock',
})

interface QuoteBlockProps {
  quote?: string
  authorName?: string
  authorRole?: string
  authorImage?: string
  ui?: {
    root?: string
    quoteText?: string
    authorBlock?: string
  }
}

withDefaults(defineProps<QuoteBlockProps>(), {
  ui: () => ({}),
})
</script>

<style lang="scss" scoped>
.quote-icon {
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.1);
  }
}

.author-image {
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
}

@include isLessThan(xl) {
  .school-quote {
    flex-direction: column;
    align-items: flex-start;
  }
}

@include isMobile {
  .school-quote {
    padding: 24px;
    gap: 24px;
  }

  .quote-icon {
    width: 32px;
    height: 32px;
  }

  .author-image {
    width: 48px;
    height: 48px;
  }
}
</style>
